// extracted by mini-css-extract-plugin
module.exports = {"root":"SwitchLabel_root__5Fnqe","switch":"SwitchLabel_switch__2_OSy"};